import { eWebinarButtonHTML } from './eWebinarButtonHTML';
import { eWebinarButtonScript } from './eWebinarButtonScript';
import './style.css';

export const SBEWebinarButton = () => (
  <div>
    <div id="script" dangerouslySetInnerHTML={{ __html: eWebinarButtonHTML }} />
    <div id="script" dangerouslySetInnerHTML={{ __html: eWebinarButtonScript }} />
  </div>
);
